function observer(delay, animate) {
	function onDisplay(entry) {
		entry.forEach(function (change) {
			if (change.isIntersecting) {
				change.target.classList.add(delay);
			} else {
				change.target.classList.remove(delay);
			}
		});
	}
	const elements = document.querySelectorAll(animate);
	const options = {
		threshold: [0.7],
	};
	const observer = new IntersectionObserver(onDisplay, options);
	for (let elm of elements) {
		observer.observe(elm);
	}
}

export default observer;
